import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MinesweeperComponent} from "./components/minesweeper/minesweeper.component";
import {GameLogicService} from "./services/game-logic.service";
import {FormsModule} from "@angular/forms";
import {BrowserModule} from "@angular/platform-browser";
import {RepeatPipe} from "../core/repeat.pipe";
import { SidebarComponent } from './components/sidebar/sidebar.component';
import {ErrorHandlerService} from "./services/error-handler.service";

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [
    MinesweeperComponent,
    RepeatPipe,
    SidebarComponent
  ],
  providers : [
    GameLogicService,
    ErrorHandlerService
  ],
  exports: [MinesweeperComponent,SidebarComponent]
})
export class MinesweeperModule { }



// WEBPACK FOOTER //
// ./src/app/minesweeper/minesweeper.module.ts